import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http/http.service';
import { StatusMessage } from '@models/companies';

@Service()
export class StatusMessageDataService {
  private readonly http = inject(HttpService);

  async addStatusMessageAsync(companyId: string, statusMessage: StatusMessage): Promise<StatusMessage> {
    return await this.http.postObjectAsync<StatusMessage, StatusMessage>(`companies/${companyId}/statusMessages`, statusMessage);
  }

  async updateStatusMessageAsync(companyId: string, shortName: string, statusMessage: StatusMessage): Promise<StatusMessage[]> {
    return await this.http.putObjectAsync<StatusMessage, StatusMessage[]>(
      `companies/${companyId}/statusMessages/by/shortname/${encodeURIComponent(shortName)}`, statusMessage);
  }

  async deleteStatusMessageAsync(companyId: string, shortName: string): Promise<StatusMessage[]> {
    return await this.http.deleteAsync<StatusMessage[]>(
      `companies/${companyId}/statusMessages/by/shortname/${encodeURIComponent(shortName)}`);
  }

  async reorderStatusMessagesAsync(companyId: string, orderedShortNames: string[]): Promise<void> {
    await this.http.putObjectAsync<string[], unknown>(`companies/${companyId}/statusMessages/order/with/shortname`, orderedShortNames);
  }
}
